import React, { useEffect, useState, cloneElement } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { CheckCircle2, ArrowRight, Star, FileText, Briefcase, Linkedin, TrendingUp, Clock, Shield, Award, Users, ChevronDown, ChevronUp, ChevronRight, MessageSquare } from 'lucide-react';
interface PageProps {
  openGetStarted?: () => void;
  openResumeReview?: () => void;
}
export function Home({
  openGetStarted,
  openResumeReview
}: PageProps) {
  return <div className="w-full" data-id="element-257" data-mp="24g8vqrlor7j6">
      <SEO title="Hirelio | Professional Resume Writing & ATS Resume Services" description="Professional resume writers helping you land more interviews. ATS resume optimization, LinkedIn profile writing, executive resumes, CV writing, and career coaching." data-id="element-258" data-mp="24hk6jbdjtfjs" />
      <Hero openGetStarted={openGetStarted} openResumeReview={openResumeReview} data-id="element-259" data-mp="3kuii5g6dam7d" />
      <Metrics data-id="element-260" data-mp="3ovkik0c0t4ax" />
      <WhyChooseUs data-id="element-261" data-mp="3ov2fokuurru1" />
      <Services data-id="element-262" data-mp="3oyqbjqnrsqbx" />
      <HowItWorks data-id="element-263" data-mp="30wjaok4gik28" />
      <Industries data-id="element-264" data-mp="30x1jeg8b2qr1" />
      <Testimonials data-id="element-265" data-mp="30vgouqlzr7t6" />
      <FAQ data-id="element-266" data-mp="30w02vw8itc1x" />
      <CTA openGetStarted={openGetStarted} data-id="element-267" data-mp="30ufbuglf0b8t" />
    </div>;
}
function Hero({
  openGetStarted,
  openResumeReview
}: PageProps) {
  return <section className="relative pt-20 pb-32 lg:pt-32 lg:pb-40 overflow-hidden" data-id="element-268" data-mp="2qxu4vppu4q2c">
      <div className="absolute inset-0 bg-grid opacity-50 z-0" data-id="element-269" data-mp="2mxa7cl1cnkfo"></div>
      <div className="absolute top-0 right-0 -mr-40 -mt-40 w-[500px] h-[500px] rounded-full bg-brand-500/10 dark:bg-brand-500/20 blur-3xl opacity-60 z-0" data-id="element-270" data-mp="2mz35td1t6ycl"></div>
      <div className="absolute bottom-0 left-0 -ml-40 -mb-40 w-[500px] h-[500px] rounded-full bg-emerald-500/10 dark:bg-emerald-500/20 blur-3xl opacity-60 z-0" data-id="element-271" data-mp="2d65sdlbobzku"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-272" data-mp="239avt7yyo997">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-273" data-mp="2376i5yb9fvvq">
          <div className="max-w-2xl" data-id="element-274" data-mp="1z6wamh7tkxer">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-50 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400 text-sm font-medium mb-6" data-id="element-275" data-mp="1u8ctcu4689sq">
              <Star size={14} className="fill-current" data-id="element-276" data-mp="1kmtk8jg3x7sp" />
              <span data-id="element-277" data-mp="1ondglksuw7ds">Rated 4.9/5 by 10,000+ Professionals</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-navy-900 dark:text-white leading-[1.1] mb-6 tracking-tight" data-id="element-278" data-mp="1an2uev2hrgyy">
              Land More Interviews With a Resume That{' '}
              <span className="text-brand" data-id="element-279" data-mp="23ayods0oeus1">Gets Results</span>
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 dark:text-slate-300 mb-8 leading-relaxed" data-id="element-280" data-mp="28a1rh6x3iqxd">
              Professionally written resumes that pass Applicant Tracking
              Systems (ATS) and impress recruiters. Get hired faster with
              Hirelio.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-281" data-mp="2ma2p8di2di8m">
              <Link to="/contact" className="bg-brand hover:bg-brand-600 text-white px-8 py-4 rounded-xl font-medium text-lg transition-all shadow-lg shadow-brand/25 hover:shadow-xl hover:shadow-brand/30 hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-282" data-mp="2m8ro6lg06ol7">
                Get Started <ArrowRight size={20} data-id="element-283" data-mp="oe4dmovaui16" />
              </Link>
              <button onClick={openResumeReview} className="bg-white dark:bg-navy-800 hover:bg-slate-50 dark:hover:bg-navy-700 text-navy-900 dark:text-white border border-slate-200 dark:border-navy-600 px-8 py-4 rounded-xl font-medium text-lg transition-all shadow-sm flex items-center justify-center" data-id="element-284" data-mp="odm9l62eazip">
                Free Resume Review
              </button>
            </div>
            <div className="mt-8 flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400" data-id="element-285" data-mp="5ljqzp67195t">
              <div className="flex -space-x-2" data-id="element-286" data-mp="qw9wbdirh19">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white dark:border-navy-900 bg-slate-200 dark:bg-navy-700" data-id="element-287" data-mp="1h4w5591f6ii6"></div>)}
              </div>
              <p data-id="element-288" data-mp="2ccg8atdx4wsc">Join 10,000+ successful job seekers</p>
            </div>
          </div>

          <div className="relative lg:ml-auto w-full max-w-lg perspective-1000" data-id="element-289" data-mp="2hccbiqeskk6u">
            <div className="relative rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(8,_112,_184,_0.07)] dark:shadow-[0_20px_50px_rgba(0,_0,_0,_0.5)] border border-white/50 dark:border-navy-700/50 bg-white/80 dark:bg-navy-800/80 backdrop-blur-xl p-2 transform-gpu rotate-y-[-8deg] rotate-x-[8deg] hover:rotate-y-0 hover:rotate-x-0 transition-transform duration-700 ease-out" data-id="element-290" data-mp="2mb5rqqlgqpap">
              <div className="bg-slate-50/50 dark:bg-navy-900/50 rounded-2xl p-6 h-[500px] relative overflow-hidden" data-id="element-291" data-mp="304nawaa8m007">
                {/* Abstract Resume Illustration */}
                <div className="w-full h-full flex flex-col gap-4 opacity-80" data-id="element-292" data-mp="3a21cx4veym8z">
                  <div className="flex items-center gap-4 border-b border-slate-200 dark:border-navy-700 pb-4" data-id="element-293" data-mp="3e1k2idy6jli5">
                    <div className="w-16 h-16 rounded-full bg-slate-200 dark:bg-navy-700" data-id="element-294" data-mp="12frkwu7s3kdr"></div>
                    <div className="space-y-2 flex-1" data-id="element-295" data-mp="ycbsyb6nm87e">
                      <div className="h-4 bg-slate-200 dark:bg-navy-700 rounded w-1/2" data-id="element-296" data-mp="tea8pmxhs2uc"></div>
                      <div className="h-3 bg-slate-200 dark:bg-navy-700 rounded w-1/3" data-id="element-297" data-mp="tg4raulajiv9"></div>
                    </div>
                  </div>
                  <div className="space-y-3" data-id="element-298" data-mp="1m1xnglc2zz92">
                    <div className="h-3 bg-brand-100 dark:bg-brand-900/30 rounded w-1/4" data-id="element-299" data-mp="1m522kdr34fei"></div>
                    <div className="h-2 bg-slate-200 dark:bg-navy-700 rounded w-full" data-id="element-300" data-mp="1h5z4jd9iv9g1"></div>
                    <div className="h-2 bg-slate-200 dark:bg-navy-700 rounded w-5/6" data-id="element-301" data-mp="1cbbbd13kpqv4"></div>
                    <div className="h-2 bg-slate-200 dark:bg-navy-700 rounded w-full" data-id="element-302" data-mp="17dt2tbtgxdnn"></div>
                  </div>
                  <div className="space-y-3 mt-4" data-id="element-303" data-mp="24vjqm50z2mtj">
                    <div className="h-3 bg-brand-100 dark:bg-brand-900/30 rounded w-1/3" data-id="element-304" data-mp="202gw9uodf9ca"></div>
                    <div className="flex gap-2" data-id="element-305" data-mp="3uacammeofr2a">
                      <div className="h-8 w-8 bg-slate-200 dark:bg-navy-700 rounded" data-id="element-306" data-mp="3ucoythb12xns"></div>
                      <div className="flex-1 space-y-2 py-1" data-id="element-307" data-mp="260d4d9hu8hm">
                        <div className="h-2 bg-slate-200 dark:bg-navy-700 rounded w-3/4" data-id="element-308" data-mp="3kjq0v8tn5uri"></div>
                        <div className="h-2 bg-slate-200 dark:bg-navy-700 rounded w-full" data-id="element-309" data-mp="3pj2ovww917vo"></div>
                      </div>
                    </div>
                    <div className="flex gap-2" data-id="element-310" data-mp="3aopqed3xs2lj">
                      <div className="h-8 w-8 bg-slate-200 dark:bg-navy-700 rounded" data-id="element-311" data-mp="3fly6871m3ujm"></div>
                      <div className="flex-1 space-y-2 py-1" data-id="element-312" data-mp="31mot5g8pdgjv">
                        <div className="h-2 bg-slate-200 dark:bg-navy-700 rounded w-5/6" data-id="element-313" data-mp="31o9pnbekv9kd"></div>
                        <div className="h-2 bg-slate-200 dark:bg-navy-700 rounded w-full" data-id="element-314" data-mp="36muph9px3r8a"></div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Floating Elements */}
                <div className="absolute top-12 -right-6 bg-white dark:bg-navy-800 p-4 rounded-xl shadow-xl border border-slate-100 dark:border-navy-700 flex items-center gap-3 animate-bounce transform-gpu translate-z-10" style={{
                animationDuration: '3s'
              }} data-id="element-315" data-mp="1ex239rxeofsn">
                  <div className="w-10 h-10 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center text-emerald-600 dark:text-emerald-400" data-id="element-316" data-mp="1ixvmw93tf8fq">
                    <CheckCircle2 size={20} data-id="element-317" data-mp="1so6uc5mpjzrd" />
                  </div>
                  <div data-id="element-318" data-mp="26p9j4q537o5z">
                    <p className="text-sm font-bold text-navy-900 dark:text-white" data-id="element-319" data-mp="26nq2uzjfld47">
                      ATS Passed
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-320" data-mp="22l1usu2jka8a">Score: 98%</p>
                  </div>
                </div>

                <div className="absolute bottom-20 -left-6 bg-white dark:bg-navy-800 p-4 rounded-xl shadow-xl border border-slate-100 dark:border-navy-700 flex items-center gap-3 animate-bounce transform-gpu translate-z-10" style={{
                animationDuration: '4s',
                animationDelay: '1s'
              }} data-id="element-321" data-mp="894xwllbyc5u">
                  <div className="w-10 h-10 rounded-full bg-brand-100 dark:bg-brand-900/30 flex items-center justify-center text-brand-600 dark:text-brand-400" data-id="element-322" data-mp="1algk3u35p1wk">
                    <TrendingUp size={20} data-id="element-323" data-mp="dws5l7qnfwrw" />
                  </div>
                  <div data-id="element-324" data-mp="itil9tyjkqcs">
                    <p className="text-sm font-bold text-navy-900 dark:text-white" data-id="element-325" data-mp="iutzknpm5gi5">
                      Interview Scheduled
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-326" data-mp="ruqi07letj4r">Tomorrow, 10:00 AM</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function Counter({
  end,
  suffix = '',
  duration = 2000
}: {
  end: number;
  suffix?: string;
  duration?: number;
}) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let startTime: number;
    let animationFrame: number;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      // Easing function (easeOutExpo)
      const easeOut = percentage === 1 ? 1 : 1 - Math.pow(2, -10 * percentage);
      setCount(Math.floor(end * easeOut));
      if (progress < duration) {
        animationFrame = requestAnimationFrame(animate);
      }
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration]);
  return <span data-id="element-327" data-mp="1gpe4mjfjautf">
      {count.toLocaleString()}
      {suffix}
    </span>;
}
function Metrics() {
  const metrics = [{
    value: 10000,
    suffix: '+',
    label: 'Resumes Written'
  }, {
    value: 95,
    suffix: '%',
    label: 'Interview Success Rate'
  }, {
    value: 4.9,
    suffix: '★',
    label: 'Customer Rating',
    isFloat: true
  }, {
    value: 50,
    suffix: '+',
    label: 'Industries Served'
  }];
  return <section className="py-12 bg-navy-900 dark:bg-navy-950 text-white border-y border-navy-800" data-id="element-328" data-mp="mlg632mc3bum">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-329" data-mp="hozhk7b82vh0">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 divide-x divide-navy-800" data-id="element-330" data-mp="3q381kqzoidxk">
          {metrics.map((metric, idx) => <div key={idx} className={`text-center ${idx % 2 === 0 ? 'border-none lg:border-solid' : ''} ${idx === 0 ? 'border-none' : ''}`} data-id="element-331" data-mp="3l5pruydu7uoi" data-mpi={idx}>
              <div className="text-3xl sm:text-4xl font-heading font-bold text-white mb-2" data-id="element-332" data-mp="3v2avpge4ezqr">
                {metric.isFloat ? '4.9' : <Counter end={metric.value} data-id="element-333" data-mp="37bozqnhe55x4" />}
                {metric.suffix}
              </div>
              <div className="text-sm text-slate-400 font-medium" data-id="element-334" data-mp="32d41uupm2ybu">
                {metric.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function WhyChooseUs() {
  const features = [{
    icon: <Award data-id="element-335" data-mp="18v6hohfau4hm" />,
    title: 'Certified Writers',
    desc: 'Work one-on-one with industry-specific, certified resume writers.'
  }, {
    icon: <Shield data-id="element-336" data-mp="1cxkzcy78ey7b" />,
    title: 'ATS-Friendly',
    desc: 'Formats and keywords optimized to pass Applicant Tracking Systems.'
  }, {
    icon: <Clock data-id="element-337" data-mp="25lgq7ma4dvw6" />,
    title: 'Fast Delivery',
    desc: 'Get your first draft in just 3-5 business days.'
  }, {
    icon: <CheckCircle2 data-id="element-338" data-mp="1rmh1yfqirj0j" />,
    title: 'Unlimited Revisions',
    desc: 'We work with you until you are 100% satisfied with the result.'
  }, {
    icon: <Users data-id="element-339" data-mp="1wmlmcgujsxw1" />,
    title: 'Industry Experts',
    desc: 'Writers matched to your specific industry and career level.'
  }, {
    icon: <Star data-id="element-340" data-mp="l5vlld8w8y9t" />,
    title: 'Satisfaction Guarantee',
    desc: "If you don't get 2x more interviews in 60 days, we'll rewrite it free."
  }];
  return <section className="py-24 bg-white/50 dark:bg-navy-900/30 backdrop-blur-sm" data-id="element-341" data-mp="2mwm00x86pwsm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342" data-mp="2hwgdfvgrv0he">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-343" data-mp="2d3wsuejo3533">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 dark:text-white mb-4" data-id="element-344" data-mp="293cy1hmkgdk4">
            Why Choose Hirelio
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400" data-id="element-345" data-mp="245uvc8z56ukk">
            We don't just write resumes; we craft career marketing documents
            designed to get you hired.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-346" data-mp="1u6dqftrpskpn">
          {features.map((feature, idx) => <div key={idx} className="bg-white dark:bg-navy-800 p-8 rounded-2xl shadow-sm border border-slate-100 dark:border-navy-700 hover:shadow-md transition-shadow" data-id="element-347" data-mp="1q6v732fjkhox" data-mpi={idx}>
              <div className="w-12 h-12 bg-brand-50 dark:bg-navy-900 text-brand rounded-xl flex items-center justify-center mb-6" data-id="element-348" data-mp="16as71n7qxr68">
                {cloneElement(feature.icon as React.ReactElement, {
              size: 24
            })}
              </div>
              <h3 className="text-xl font-heading font-bold text-navy-900 dark:text-white mb-3" data-id="element-349" data-mp="1g1dfs3h4wc2v">
                {feature.title}
              </h3>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed" data-id="element-350" data-mp="ncfyo3onslbp">
                {feature.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
function Services() {
  const services = [{
    icon: <FileText data-id="element-351" data-mp="wep8erc3sao1" />,
    title: 'Professional Resume',
    desc: 'For mid-level professionals looking to take the next step.',
    slug: 'resume'
  }, {
    icon: <Briefcase data-id="element-352" data-mp="27qyd670dzkj7" />,
    title: 'Executive Resume',
    desc: 'Strategic positioning for Directors, VPs, and C-Suite.',
    slug: 'executive'
  }, {
    icon: <Linkedin data-id="element-353" data-mp="2b95m5g38p14p" />,
    title: 'LinkedIn Optimization',
    desc: 'Attract recruiters directly to your profile.',
    slug: 'linkedin'
  }, {
    icon: <MessageSquare data-id="element-354" data-mp="26coz6p7s0st7" />,
    title: 'Cover Letter',
    desc: 'Compelling narratives that complement your resume.',
    slug: 'cover-letter'
  }];
  return <section className="py-24 relative" data-id="element-355" data-mp="2g7pd5uwox33x">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-356" data-mp="2gb4ruwmgca4t">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-357" data-mp="2u6oyotowp1vv">
          <div className="max-w-2xl" data-id="element-358" data-mp="2p8x57v8m57pk">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 dark:text-white mb-4" data-id="element-359" data-mp="33yctn4ko9123">
              Our Career Services
            </h2>
            <p className="text-lg text-slate-600 dark:text-slate-400" data-id="element-360" data-mp="2yzrtt69c0je6">
              Comprehensive solutions to accelerate your job search and land
              your dream role.
            </p>
          </div>
          <Link to="/services" className="inline-flex items-center gap-2 text-brand font-medium hover:text-brand-600 transition-colors" data-id="element-361" data-mp="381rbm0s67ri6">
            View All Services <ArrowRight size={20} data-id="element-362" data-mp="ewyydb3wf7c" />
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 perspective-1000" data-id="element-363" data-mp="3iltd1jz5rnix">
          {services.map((service, idx) => <Link to={`/services/${service.slug}`} key={idx} className="group p-8 rounded-3xl border border-white/60 dark:border-navy-700/50 hover:border-brand/50 dark:hover:border-brand/50 transition-all cursor-pointer transform-gpu hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)] dark:hover:shadow-[0_20px_40px_rgba(0,0,0,0.4)] bg-white/60 dark:bg-navy-800/60 backdrop-blur-md" data-id="element-364" data-mp="3ml29wxphw1ip" data-mpi={idx}>
              <div className="text-slate-400 group-hover:text-brand transition-colors mb-6" data-id="element-365" data-mp="2pvukvfpo3aa1">
                {cloneElement(service.icon as React.ReactElement, {
              size: 32
            })}
              </div>
              <h3 className="text-xl font-heading font-bold text-navy-900 dark:text-white mb-3" data-id="element-366" data-mp="10g0pesr1bhj1">
                {service.title}
              </h3>
              <p className="text-slate-600 dark:text-slate-400 mb-6 text-sm leading-relaxed" data-id="element-367" data-mp="qpfh2dlk6ymx">
                {service.desc}
              </p>
              <span className="inline-flex items-center gap-1 text-sm font-medium text-brand group-hover:text-brand-600 transition-colors" data-id="element-368" data-mp="movj57t5vqzq">
                Learn More{' '}
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-369" data-mp="1eei7oay681tk" />
              </span>
            </Link>)}
        </div>
      </div>
    </section>;
}
function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Upload Existing Resume',
    desc: 'Share your current resume or fill out our brief career questionnaire.'
  }, {
    num: '02',
    title: 'Choose a Package',
    desc: 'Select the service level that fits your career goals and experience.'
  }, {
    num: '03',
    title: 'Work with Your Writer',
    desc: 'Collaborate 1-on-1 with your industry-matched expert writer.'
  }, {
    num: '04',
    title: 'Receive Your New Resume',
    desc: 'Get your ATS-optimized documents and start landing interviews.'
  }];
  return <section className="py-24 bg-navy-900 text-white overflow-hidden relative" data-id="element-370" data-mp="2od9shf7sm9mw">
      <div className="absolute inset-0 bg-grid opacity-20" data-id="element-371" data-mp="2ofdzi60znore"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-372" data-mp="2tajhwuv6mlaq">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-373" data-mp="2yc8voi9shd2i">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4" data-id="element-374" data-mp="32cstlo26skpp">
            How It Works
          </h2>
          <p className="text-lg text-slate-400" data-id="element-375" data-mp="13xoc68x7fnkp">
            A streamlined process designed to respect your time and deliver
            results.
          </p>
        </div>

        <div className="relative" data-id="element-376" data-mp="p2j7y93cdplz">
          {/* Connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-navy-800 -translate-y-1/2 z-0" data-id="element-377" data-mp="p0olurgc3rgb"></div>

          <div className="grid md:grid-cols-4 gap-12 md:gap-8 relative z-10" data-id="element-378" data-mp="k1lqjyq5ozlj">
            {steps.map((step, idx) => <div key={idx} className="relative text-center" data-id="element-379" data-mp="tthrrinjh5tz" data-mpi={idx}>
                <div className="w-16 h-16 mx-auto bg-brand rounded-2xl flex items-center justify-center text-2xl font-heading font-bold mb-6 shadow-lg shadow-brand/20" data-id="element-380" data-mp="tu15soa2ja2q">
                  {step.num}
                </div>
                <h3 className="text-xl font-heading font-bold mb-3" data-id="element-381" data-mp="f4btbwwizjn5">
                  {step.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-382" data-mp="a4qurnl9pday">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}
function Industries() {
  const industries = ['Information Technology', 'Healthcare & Medical', 'Finance & Accounting', 'Engineering', 'Marketing & PR', 'Sales & Business Dev', 'Human Resources', 'Education', 'Legal', 'Government & Federal', 'Hospitality', 'Project Management'];
  return <section className="py-24 relative" data-id="element-383" data-mp="1k5333xise3sn">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-384" data-mp="1p1tei7jncb7q">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-385" data-mp="2crxi4ewu4ayq">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 dark:text-white mb-4" data-id="element-386" data-mp="2csflrwlttrgo">
            Industries We Serve
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400" data-id="element-387" data-mp="232e1lfwlgt71">
            Our writers have specialized experience across all major sectors.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-388" data-mp="27yune3gbmvgy">
          {industries.map((industry, idx) => <div key={idx} className="p-4 rounded-2xl border border-white/60 dark:border-navy-700/50 bg-white/40 dark:bg-navy-800/40 backdrop-blur-sm text-center hover:border-brand/50 dark:hover:border-brand/50 hover:shadow-md hover:-translate-y-1 transition-all cursor-default" data-id="element-389" data-mp="30i090rp0javr" data-mpi={idx}>
              <span className="font-medium text-slate-700 dark:text-slate-200" data-id="element-390" data-mp="m6ca6a7sqhkt">
                {industry}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}
function Testimonials() {
  const testimonials = [{
    name: 'Sarah Jenkins',
    role: 'Marketing Director',
    company: 'TechCorp',
    text: 'Hirelio completely transformed my resume. Within two weeks of sending out the new version, I had 4 interviews lined up. The writer really understood how to highlight my achievements.',
    rating: 5
  }, {
    name: 'Michael Chen',
    role: 'Software Engineer',
    company: 'Startup Inc',
    text: 'The ATS optimization is real. I was getting auto-rejected before, but the Hirelio resume got me past the filters. Landed a senior role with a 30% pay bump.',
    rating: 5
  }, {
    name: 'David Rodriguez',
    role: 'VP of Operations',
    company: 'Global Logistics',
    text: 'The executive package was worth every penny. The LinkedIn rewrite alone brought recruiters directly to me. Highly professional and efficient process.',
    rating: 5
  }];
  return <section className="py-24 bg-slate-50 dark:bg-navy-900/50" data-id="element-391" data-mp="2vfth4gf02fkv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-392" data-mp="2vi681j2qk0a2">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-393" data-mp="2qfxeaki1gu6w">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 dark:text-white mb-4" data-id="element-394" data-mp="34ghvjc8b2hya">
            Success Stories
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400" data-id="element-395" data-mp="30fo7miuv535e">
            Don't just take our word for it. See what our clients have to say.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 perspective-1000" data-id="element-396" data-mp="161wx7h4pmf8w">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white/80 dark:bg-navy-800/80 backdrop-blur-md p-8 rounded-3xl shadow-sm border border-white/60 dark:border-navy-700/50 transform-gpu transition-all duration-500 hover:-translate-y-2 hover:shadow-xl" data-id="element-397" data-mp="3576t7hathoq9" data-mpi={idx}>
              <div className="flex gap-1 text-amber-400 mb-6" data-id="element-398" data-mp="3k3fok7rl7hxe">
                {[...Array(t.rating)].map((_, i) => <Star key={i} size={18} className="fill-current" data-id="element-399" data-mp="3o3zkj80fcfhy" data-mpi={i} />)}
              </div>
              <p className="text-slate-600 dark:text-slate-300 mb-8 leading-relaxed italic" data-id="element-400" data-mp="3t29krx10a6af">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-401" data-mp="6o9n5dpy39ge">
                <div className="w-12 h-12 rounded-full bg-slate-200 dark:bg-navy-700 flex items-center justify-center font-heading font-bold text-slate-500 dark:text-slate-400" data-id="element-402" data-mp="6nq6e0c16r3y">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-403" data-mp="207088bcjbyku">
                  <h4 className="font-heading font-bold text-navy-900 dark:text-white" data-id="element-404" data-mp="207i2j2fn02q4">
                    {t.name}
                  </h4>
                  <p className="text-sm text-slate-500 dark:text-slate-400" data-id="element-405" data-mp="1w3tvckux395e">
                    {t.role} at {t.company}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function FAQ() {
  const faqs = [{
    q: 'How long does resume writing take?',
    a: 'Our standard turnaround time is 3-5 business days after we receive your information. Executive packages have a 48-hour turnaround option.'
  }, {
    q: 'Is the resume ATS-friendly?',
    a: 'Yes, absolutely. All our resumes are formatted and keyword-optimized specifically to pass modern Applicant Tracking Systems used by 99% of Fortune 500 companies.'
  }, {
    q: 'Do I work with a real writer?',
    a: 'Yes. You will be paired with a certified, human resume writer who has experience in your specific industry. We do not use AI to generate final resumes.'
  }, {
    q: 'How many revisions are included?',
    a: 'Our Professional and Executive packages include unlimited revisions for 14 days after you receive the first draft. The Starter package includes 2 rounds of revisions.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-24 relative" data-id="element-406" data-mp="312p39sh5gz0p">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-407" data-mp="313qpmt3m97xq">
        <div className="text-center mb-12" data-id="element-408" data-mp="361a4nv851oqq">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 dark:text-white mb-4" data-id="element-409" data-mp="3644obkjbv5j3">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-410" data-mp="2waxmg9nsq7nr">
          {faqs.map((faq, idx) => <div key={idx} className="border border-slate-200 dark:border-navy-700 rounded-xl overflow-hidden" data-id="element-411" data-mp="3k11o4bhfbxc4" data-mpi={idx}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center bg-white dark:bg-navy-800 hover:bg-slate-50 dark:hover:bg-navy-700/50 transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-412" data-mp="3oumgno08zz3x">
                <span className="font-heading font-semibold text-navy-900 dark:text-white" data-id="element-413" data-mp="1m88l8rizdme8">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp size={20} className="text-slate-400" data-id="element-414" data-mp="ufhxl5fd560l" /> : <ChevronDown size={20} className="text-slate-400" data-id="element-415" data-mp="ph6nctl5othu" />}
              </button>
              {openIdx === idx && <div className="px-6 py-4 bg-slate-50 dark:bg-navy-900/50 border-t border-slate-200 dark:border-navy-700" data-id="element-416" data-mp="ygjqz5mlmnun">
                  <p className="text-slate-600 dark:text-slate-300 leading-relaxed" data-id="element-417" data-mp="2eu0h5n5y6vey">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}
function CTA({
  openGetStarted
}: {
  openGetStarted?: () => void;
}) {
  return <section className="py-24 bg-brand relative overflow-hidden" data-id="element-418" data-mp="1cg2jhad1vkk9">
      <div className="absolute inset-0 bg-grid opacity-20" data-id="element-419" data-mp="1gih4o146ywep"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-420" data-mp="1ggwc2h1ftnjh">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-421" data-mp="1lfzf5vxuxjot">
          Ready to Land Your Dream Job?
        </h2>
        <p className="text-xl text-brand-100 mb-10 max-w-2xl mx-auto" data-id="element-422" data-mp="st4uaxx4oiat">
          Join thousands of professionals who have accelerated their careers
          with Hirelio.
        </p>
        <Link to="/contact" className="inline-block bg-white text-brand hover:bg-slate-50 px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-xl hover:shadow-2xl hover:-translate-y-1" data-id="element-423" data-mp="12j7ov2jwe4b9">
          Get Started Today
        </Link>
      </div>
    </section>;
}